export const PERMS = {
    READ: 'report_cost_type_costs.read',
    EXPORT: 'report_cost_type_costs.export',
}
